import { Box, BoxProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

const PREFIX_CLASSNAME = "ContentWithAside"

export const ContentWithAsideClasses = {
  root: `${PREFIX_CLASSNAME}-root`,
  contentWrapper: `${PREFIX_CLASSNAME}-contentWrapper`,
  asideWrapper: `${PREFIX_CLASSNAME}-asideWrapper`,
}

export interface IContentWithAsideProps extends BoxProps {
  aside: React.ReactNode
}

export const ContentWithAside = ({
  children,
  aside,
  ...props
}: IContentWithAsideProps) => {
  const theme = useTheme()
  const { sx, ...restProps } = props
  const styleOverrides =
    theme.components[`AppContentWithAside`]?.styleOverrides || {}
  const { root, contentWrapper, asideWrapper } = styleOverrides
  return (
    <Box
      sx={deepmerge(root, sx)}
      className={ContentWithAsideClasses.root}
      {...restProps}
    >
      <Box
        sx={contentWrapper}
        className={ContentWithAsideClasses.contentWrapper}
      >
        {children}
      </Box>
      <Box sx={asideWrapper} className={ContentWithAsideClasses.asideWrapper}>
        {aside}
      </Box>
    </Box>
  )
}
